'use client';
import { useTranslations } from '@dealerportal/i18n/client';
import Link from 'next/link';
import type { FC } from 'react';

export const ProductsNotFound: FC = () => {
  const t = useTranslations('products');

  return (
    <div id="empty-result">
      <h2 className="!ui-text-left !ui-text-2xl">{t('noResultsFound')}</h2>
      <p className="!ui-mt-3 ui-text-base">
        {t.rich('noResultsMessage', {
          productsLink: (chunks) => (
            <Link href="/p" prefetch={false} aria-label="Link to page products">
              {chunks}
            </Link>
          ),
          contactLink: (chunks) => (
            <Link
              href="/contact"
              prefetch={false}
              aria-label="Link to page contact"
            >
              {chunks}
            </Link>
          ),
        })}
      </p>
    </div>
  );
};
